import Dexie, { Table } from 'dexie'
import { createJSONStorage } from 'zustand/middleware'

// ─── Base KV dédiée au stockage des stores Zustand ────────────────────────────

interface KVEntry {
   key: string
   value: string
}

class KVDatabase extends Dexie {
   json!: Table<KVEntry, string>

   constructor() {
      super('ref_m3')
      this.version(1).stores({
         json: '&key' // clé primaire unique = nom du store ("models", "sales")
      })
   }
}

const kvDb = new KVDatabase()

// ─── Migration one-shot : localStorage → IndexedDB ────────────────────────────
// Appelée lors du premier getItem de chaque store.
// Si une entrée localStorage existe, elle est copiée dans IndexedDB puis supprimée.

async function migrateFromLocalStorage(key: string): Promise<void> {
   const raw = localStorage.getItem(key)
   if (raw !== null) {
      await kvDb.json.put({ key, value: raw })
      localStorage.removeItem(key)
   }
}

// ─── Adaptateur de stockage async pour Zustand persist ────────────────────────

const idbStorage = {
   getItem: async (name: string): Promise<string | null> => {
      await migrateFromLocalStorage(name)
      const entry = await kvDb.json.get(name)
      return entry?.value ?? null
   },
   setItem: async (name: string, value: string): Promise<void> => {
      await kvDb.json.put({ key: name, value })
   },
   removeItem: async (name: string): Promise<void> => {
      await kvDb.json.delete(name)
   }
}

export const idbJSONStorage = createJSONStorage(() => idbStorage)

export const clearIdbStorage = () => kvDb.json.clear()
